import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ec2c1a1c")

_pushScopeId("data-v-ec2c1a1c")
const _hoisted_1 = {
  key: 0,
  class: "error-message"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ion_item, {
      class: {'ion-invalid': _ctx.errorMessage, 'ion-touched': _ctx.errorMessage }
    }, {
      default: _withId(() => [
        _createVNode(_component_ion_label, {
          class: {'ion-text-wrap':_ctx.wrapLabel},
          color: "medium",
          position: _ctx.wrapLabel ? undefined : 'floating'
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }, 8, ["class", "position"]),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["class"]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock("p", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 64))
})